import { gql } from '@apollo/client'

export const GEOOGRAPHIC_HIERARCHY_DRAFT = gql`
  fragment GeographicHierarchyDraft on RouteDraft {
    rar {
      uuid
      id
      email
      firstName
      lastName
      username
      customerUserId
      mainRole
      roles
    }
    stores {
      id
      name
      internalStoreId
      category
      image {
        id
        url
      }
      address {
        ...StoreAddress
      }
    }
    approvedBy {
      firstName
      lastName
    }
    routeId
    routeName
  }
`
